exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-datepicker-popup .mat-datepicker-content .mat-calendar {\n  width: 240px;\n  height: 300px;\n}\n[data-component='period-filter'] {\n  padding: 0 0 40px;\n}\n[data-component='period-filter'] p {\n  margin: 0 0 35px;\n}\n[data-component='period-filter'] .period-layer .input-container {\n  display: inline-block;\n  width: 255px;\n}\n[data-component='period-filter'] .period-layer .input-container:first-child {\n  margin-right: 20px;\n}\n[data-component='period-filter'] .period-layer .input-container label {\n  display: inline-block;\n  margin-right: 10px;\n  vertical-align: middle;\n}\n[data-component='period-filter'] .period-layer .input-container .datepicker-holder {\n  vertical-align: middle;\n  display: inline-block;\n  width: 220px;\n}\n[data-component='period-filter'] .period-layer .btn {\n  max-width: 220px;\n  margin-left: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/investments-period/period-filter/period-filter.component.styl
// module id = ../../../../../src/app/master/investments/investments-period/period-filter/period-filter.component.styl
// module chunks = main